import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_OPEN_RESPONSE_MODAL,
} from '../../constants'

const init = fromJS({
  keywordSearch: '',
  responseModal: {
    isOpen: false,
    res: {},
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_OPEN_RESPONSE_MODAL:
      return state
        .set('responseModal', action.payload.responseModal)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-reducer.js